import React from "react";
import { MenuItemOption, Icon } from "@chakra-ui/react";
import { CheckIcon } from "@heroicons/react/24/outline";
export function FilterMenuOption(props) {
    return (React.createElement(MenuItemOption, { icon: React.createElement(Icon, { as: CheckIcon, boxSize: 5 }), ...props }));
}
// This is required for Chakra UI to recognize `FilterMenuOption` as a valid child
// of `MenuOptionGroup` and assign custom props to handle the selection of options.
//
// See https://github.com/chakra-ui/chakra-ui/blob/c595d045c26e0fed2da35bbe6f4eb9bf6939947b/packages/menu/src/use-menu.ts#L739-L746
FilterMenuOption.id = "MenuItemOption";
